class ProductReview extends HTMLElement {
    constructor() {
        super();

        this.reviewContainer = document.getElementById('product-review');
        this.averageScoreElement = document.getElementById('review-average-score');
        this.reviewsHeader = document.getElementById('header-tab-reviews');
        this.questionsHeader = document.getElementById('header-tab-questions');
        this.goToReviewLink = document.getElementById('testfreaks-badge');
        this.writeReviewLink = document.getElementById('write-review-link');
        this.tfTabWrite = document.getElementById('tf-tab-write');
        this.askLink = document.getElementById('qa-review-link');
        this.tfTabAsk = document.getElementById('tf-tab-ask');
        this.tabHeaders = document.querySelectorAll('.tabs-testfreaks-header .tab-header');
        this.tabContents = document.querySelectorAll('.tabs-testfreaks-content .tab-content');

        this.fetchAndRenderReviews();
		this.applyDefaultSort();
        this.renderTabs(this.tabHeaders, this.tabContents);
        this.setupMobileReviewAccordion();
    }

    /**
     * MOBILE only: TestFreaks's Expert/User review accordions are single-select
     * (opening one closes the other) — we keep that vendor behaviour. But the
     * vendor has an icon bug: when it closes the inactive panel it leaves that
     * header showing the "−" (iconcollapse) glyph instead of "+". After each
     * accordion toggle we re-sync each header's +/− icon (plus the divider
     * `selected` state and `aria-expanded`) to its panel's ACTUAL open/closed
     * state. Desktop drives these panels via the pills, so this is gated to
     * mobile and only ever touches the (mobile-only) accordion headers.
     */
    setupMobileReviewAccordion() {
        const PRO = 'button.accordion[aria-controls="tf-panel-pro"]';
        const mq = window.matchMedia('(max-width: 749px)');

        this.waitForElement(PRO, () => {
            const pairs = [
                [document.querySelector('button.accordion[aria-controls="tf-panel-pro"]'), document.getElementById('tf-panel-pro')],
                [document.querySelector('button.accordion[aria-controls="tf-panel-user"]'), document.getElementById('tf-panel-user')],
            ].filter(([btn, panel]) => btn && panel);
            if (!pairs.length) return;

            const syncOne = (btn, panel) => {
                const open = getComputedStyle(panel).display !== 'none';
                btn.classList.toggle('iconcollapse', open);  // − when open
                btn.classList.toggle('iconexpand', !open);   // + when closed
                btn.classList.toggle('selected', open);
                btn.setAttribute('aria-expanded', open ? 'true' : 'false');
            };
            const syncAll = () => { if (mq.matches) pairs.forEach(([b, p]) => syncOne(b, p)); };

            // Re-sync after the vendor processes each accordion click (the panel
            // display flips synchronously; the 80ms pass is a safety net).
            pairs.forEach(([btn]) => btn.addEventListener('click', () => {
                setTimeout(syncAll, 0);
                setTimeout(syncAll, 80);
            }));
            syncAll();
        });
    }

    applyDefaultSort() {
      this.waitForElement("#tf-tab-rsort", () => {
          const desktop = document.getElementById("tf-tab-rsort");
          const mobile = document.getElementById("tf-acc-rsort");
          if (desktop) desktop.value = "date";
          if (mobile) mobile.value = "date";
      });
    }

    async fetchAndRenderReviews() {
        const productId = this.getAttribute('product-id');
        const productUrl = this.getAttribute('product-url');

        const data = await this.fetchReviewData(productId);

        if (data) {
            this.renderContents(data, productUrl);
            this.reviewContainer.style.display = 'block';
            this.renderHeader(data);
        }
    }

    async fetchReviewData(productId) {
        const url = `https://js.testfreaks.com/onpage/georges.com.au/reviews.json?key=${productId}`;

        try {
            const response = await fetch(url);
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            return await response.json();
        } catch (error) {
            console.error('There was a problem with the fetch operation:', error);
        }
    }

    renderTabs(tabHeaders, tabContents) {
        if (tabHeaders.length > 0 && tabContents.length > 0) {
            tabHeaders[0].classList.add('active-tab');
            tabContents[0].classList.add('active-tab');
        }

        tabHeaders.forEach(header => {
            header.addEventListener('click', () => {
                this.switchTab(header, tabHeaders, tabContents);
            });
        });

        // Initialize the Reviews tab logic on first load
        this.initializeReviewLogic();

        // Set up the write review link to open the relevant tab and trigger the write review action
        if (this.writeReviewLink) {
            this.writeReviewLink.addEventListener('click', (event) => {
                event.preventDefault();
                this.switchToTab('testfreaks-reviews');
                this.initializeReviewLogic(() => {
                    this.tfTabWrite.click();
                });
            });
        }
        
        if (this.goToReviewLink) {
            this.goToReviewLink.addEventListener('click', (event) => {
                event.preventDefault();
                const reviewTabHeader = document.querySelector('[data-sticky-menu-tab-item="reviews"]');
                if (reviewTabHeader && !reviewTabHeader.classList.contains('active')) {
                    reviewTabHeader.click();
                    setTimeout(function(){
                        window.scrollTo({
                            top: reviewTabHeader.closest('.tabs-section').getBoundingClientRect().top,
                            behavior: "smooth"
                        });
                    }, 200);
                }
            });
        }

        // Set up the ask question link to open the relevant tab and trigger the ask question action
        if (this.askLink) {
            this.askLink.addEventListener('click', (event) => {
                event.preventDefault();
                this.switchToTab('testfreaks-qa');
                this.initializeQaLogic(() => {
                    this.tfTabAsk.click();
                });
            });
        }
    }

    switchTab(header, tabHeaders, tabContents) {
        // Remove 'active' class from all headers and contents
        tabHeaders.forEach(h => h.classList.remove('active-tab'));
        tabContents.forEach(content => content.classList.remove('active-tab'));

        // Add 'active' class to the clicked tab and corresponding content
        header.classList.add('active-tab');
        const targetContent = document.getElementById(header.getAttribute('data-target'));
        if (targetContent) {
            targetContent.classList.add('active-tab');
        }

        // Initialize the logic depending on which tab is clicked
        if (header.getAttribute('data-target') === 'testfreaks-qa') {
            this.initializeQaLogic();
        } else if (header.getAttribute('data-target') === 'testfreaks-reviews') {
            this.initializeReviewLogic();
        }
    }

    switchToTab(targetTabId) {
        const header = Array.from(this.tabHeaders).find(header => header.getAttribute('data-target') === targetTabId);
        if (header) {
            this.switchTab(header, this.tabHeaders, this.tabContents);
        }
    }

    initializeReviewLogic(callback) {
        this.waitForElement('#testfreaks-reviews', () => {
            this.waitForElement('#tf-tab-write', () => {
                this.tfTabWrite = document.getElementById('tf-tab-write');
                if (callback) callback();
            });
        });
    }

    initializeQaLogic(callback) {
        this.waitForElement('#testfreaks-qa', () => {
            this.waitForElement('#tf-tab-ask', () => {
                this.tfTabAsk = document.getElementById('tf-tab-ask');
                if (callback) callback();
            });
        });
    }

    renderHeader(data) {
    // Use default values (0) if review or question counts are undefined or NaN
    const userReviewCount = data.user_review_count || 0;
    const proReviewCount = data.pro_review_count || 0;
    const yourReviewCount = data.your_review_count !== undefined && data.your_review_count !== null
        ? data.your_review_count
        : 0;
    const questionCount = data.your_question_count !== undefined && data.your_question_count !== null
        ? data.your_question_count
        : 0;

    // Calculate total review count
    // If your_review_count doesn't exist, just use pro + user counts (they're separate review types)
    const reviewCount = yourReviewCount > 0
        ? userReviewCount + proReviewCount + yourReviewCount
        : userReviewCount + proReviewCount;

        const reviewsHtml = `
          <div class="testfreaks-reviews">
            <div class="reviews-title-count">Reviews (${reviewCount})</div>
          </div>`;

        const questionsHtml = `
          <div class="testfreaks-questions">
            <div class="questions-title-count">Questions & Answers (${questionCount})</div>
          </div>`;

        if (this.reviewsHeader) {
            this.reviewsHeader.innerHTML = reviewsHtml;
        }
        if (this.questionsHeader) {
            this.questionsHeader.innerHTML = questionsHtml;
        }
    }

    renderContents(data, productUrl) {
        // Calculate average score with fallback.
        // `score` is 1-10, `your_avg_score` is 1-5.
        //
        // Prefer `score`: it is TestFreaks' aggregate across ALL user-type reviews
        // (the store's own + the ones aggregated from other retailers), which is the
        // population the "Reviews (N)" count beside the badge describes.
        // `your_avg_score` covers ONLY the store's own reviews — on the Canon R5 II
        // that is 6 of 58, and it read 5.0 next to a count of 58 while the true
        // average was 4.5. It also disagreed with the ratingValue we publish in the
        // JSON-LD below (already score/2), i.e. Google saw 4.5 and shoppers saw 5.0.
        // Kept as the fallback for products TestFreaks returns no aggregate for.
        let avgScore = null;
        if (data.score !== undefined && data.score !== null) {
            // Convert from 10-point scale to 5-point scale
            avgScore = data.score / 2;
        } else if (data.your_avg_score !== undefined && data.your_avg_score !== null) {
            avgScore = data.your_avg_score;
        }

        // Calculate review count with fallback
        const userReviewCount = data.user_review_count || 0;
        const proReviewCount = data.pro_review_count || 0;
        const yourReviewCount = data.your_review_count !== undefined && data.your_review_count !== null
            ? data.your_review_count
            : 0;
        
        // ratingCount must describe the SAME population as ratingValue, or the rich
        // result is self-contradictory. ratingValue is `score / 2`, TestFreaks'
        // aggregate over the user-type reviews (own + external), so pair it with that
        // count. Previously this was `your_review_count` (6) next to a value averaged
        // over 51. Expert reviews are excluded from `score`, so they're only used as a
        // fallback for products that carry nothing else.
        const ratingCount = (yourReviewCount + userReviewCount) || proReviewCount;

        if (avgScore !== null) {
            // The star fill is clipped by the width % below. It MUST carry `!important`:
            // the vendor stylesheet has `.testfreaks-badge .tf-stars-svg { width: 7.091em
            // !important }`, and a stylesheet !important beats a plain inline declaration —
            // so without it the fill was pinned to a constant 92.17px (72% of the 128px
            // track ≈ 3.6 stars) for EVERY rating, regardless of the number beside it.
            // An inline !important outranks the vendor rule, so the fill tracks the score.
            const scoreHtml = `
                <div class="testfreaks-badge testfreaks-badge-custom">
                  <div class="testfreaks">
                    <div class="tf-row">
                      <div class="tf-score">
                        <div class="tf-stars tf-stars-svg">
                          <div class="tf-stars-svg tf-stars-fg" style="width: ${avgScore * 20}% !important;"></div>
                        </div>
                      </div>
                      <div class="tf-rating">${avgScore.toFixed(1)}</div>
                    </div>
                  </div>
                </div>
                <script type="application/ld+json">
                      {
                        "@id": "${productUrl.replace('www.georges.com.au}', '')}#product",
                        "@context": "https://schema.org",
                        "aggregateRating": {
                          "@type": "AggregateRating",
                          "ratingValue": "${((data.score)/2).toFixed(1)}",
                          "ratingCount": ${parseInt(ratingCount)}
                        }
                      }
                </script>`;

            if (this.averageScoreElement) {
                this.averageScoreElement.innerHTML = scoreHtml;
            }
        } else {
            // Handle the case where there are no reviews
            const noReviewsHtml = `
                <div class="testfreaks-badge testfreaks-badge-custom">
                  <div class="testfreaks">
                    <div class="tf-row">
                      <div class="tf-no-reviews">
                        No reviews yet.
                      </div>
                    </div>
                  </div>
                </div>`;

            if (this.averageScoreElement) {
                this.averageScoreElement.innerHTML = noReviewsHtml;
            }
        }
    }

    waitForElement(selector, callback) {
        const element = document.querySelector(selector);
        if (element) {
            callback();
        } else {
            const observer = new MutationObserver(() => {
                if (document.querySelector(selector)) {
                    callback();
                    observer.disconnect();
                }
            });

            observer.observe(document.body, { childList: true, subtree: true });
        }
    }
}

customElements.define('product-review', ProductReview);
